import { Button, Card, Form, Input, Space } from "antd";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import LockIcon from "../_icons/LockIcon";
import UserInfo from "./UserInfo";

export default function ChangePassword() {
  const [form] = Form.useForm();

  const leaveSettingsTabList = [
    {
      label: "User Info",
      link: `/organization/settings`,
    },
    // {
    //   label: "Change Password",
    //   link: `/organization/settings/change-password`,
    // },
  ];

  const onFinish = (values: any) => {};

  return (
    <>
      <SidebarLayout title="Settings" tabList={leaveSettingsTabList}>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
          {/* Left Section */}
          <div className="space-y-4">
            <UserInfo />
          </div>
          {/* Right Section */}
          <div className="lg:col-span-2 space-y-4">
            <Card className="w-[470px]">
              <h4 className=" font-semibold text-[18px] text-[#5E718D]">
                Change Password
              </h4>

              <Form
                className="custom-form"
                layout="vertical"
                requiredMark="optional"
                size="large"
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  name="oldPassword"
                  label="Old Password"
                  className="mb-[18px] mt-6"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your old password",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Form.Item
                  name="newPassword"
                  label="New Password"
                  className="mb-[18px] mt-3"
                  rules={[
                    {
                      required: true,
                      message: "Please enter password",
                    },
                    {
                      min: 8,
                      message: "Password must be minimum 8 characters.",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Confirm New Password"
                  className="mb-[18px] mt-3"
                  rules={[
                    {
                      required: true,
                      message: "Please enter confirm password",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Password and Confirm password do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Space className="flex gap-2 mt-6">
                  <Button
                    className="normal-dark-button modal-button"
                    size="middle"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="modal-button"
                    type="primary"
                    htmlType="submit"
                    size="middle"
                  >
                    Save
                  </Button>
                </Space>
              </Form>
            </Card>
          </div>
        </div>
      </SidebarLayout>
    </>
  );
}
